const s = {
  name: "Draw",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M31.1,1.5c1-1,2.3-1.5,3.7-1.5C37.7,0,40,2.3,40,5.2c0,1.4-0.5,2.7-1.5,3.7L33.4,14H40v26H0V14h20v-1.4
			L31.1,1.5z M27.4,20h-0.8c2,1.6,3.3,4.2,3.3,7c0,5-4,9-9,9c-3.3,0-6-2.7-6-6s2.7-6,6-6c2.2,0,4,1.8,4,4h-2c0-1.1-0.9-2-2-2
			c-2.2,0-4,1.8-4,4s1.8,4,4,4c3.9,0,7-3.1,7-7s-3.1-7-7-7h-1v-4H2v22h36V16h-6.6L27.4,20z M32.5,2.9L22,13.4V18h4.6L37.1,7.5
			C37.7,6.9,38,6.1,38,5.2C38,3.5,36.5,2,34.8,2C33.9,2,33.1,2.3,32.5,2.9z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Draw
};
